var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 68,
    viewBox: "0 0 393 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7 23.4L9.3 35.7C9.2 35.8 9.1 35.9 9 36L4.5 38.7C1.7 40.4 0 43.4 0 46.6V61.8C0 66.1 4.6 68.7 8.3 66.6L31 53.6C32.6 52.7 34.6 52.7 36.2 53.6L58.7 66.6C62.4 68.8 67 66.1 67 61.8V46.6C67 43.4 65.3 40.4 62.6 38.7L57.6 35.7L37.8 23.7C35.1 21.8 32.4 21.8 29.7 23.4Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1 61.8C67.1 65.1 62.3 64.1 59.4 62.5L36.9 49.5C34.9 48.3 32.4 48.3 30.3 49.5L7.6 62.5C4.8 64.2 0 65.1 0 61.8C0 66.1 4.6 68.7 8.3 66.6L31 53.6C32.6 52.7 34.6 52.7 36.2 53.6L58.7 66.6C62.4 68.7 67.1 66 67.1 61.8Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.900029 25.3C2.40003 27.7 5.50003 28.8 8.30003 27.7C8.50003 27.6 8.70003 27.6 8.90003 27.5C9.00003 27.4 9.20003 27.4 9.30003 27.3L31.6 13.8C32.7 13.2 34.1 13.2 35.2 13.8L57.6 27.4C60.6 29.2 64.4 28 66 25.4C67.6 22.6 66.6 19.1 63.9 17.5L35.9 1.19998C34.5 0.399976 32.8 0.399976 31.4 1.19998L3.10003 17.5C0.300029 19.1 -0.599971 22.5 0.900029 25.3Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9 22.6C66.9 23.1 66.7 23.9 66.3 24.5C64.8 26.9 60.8 25.6 58.5 24.2L36.1 10.6C34.5 9.69999 32.6 9.69999 31 10.6L8.39999 24.2L8.19999 24.3C7.99999 24.4 7.89999 24.4 7.89999 24.4V24.4L7.79999 24.5C5.69999 25.3 2.49999 27.1 0.799988 24.5C0.499988 23.9 0.299988 23.1 0.299988 22.5C0.299988 23.4 0.499988 24.4 0.999988 25.3C2.49999 27.7 5.59999 28.9 8.39999 27.8C8.59999 27.7 8.79999 27.7 8.99999 27.6C9.09999 27.5 9.29999 27.5 9.39999 27.4L31.7 13.9C32.9 13.3 34.2 13.3 35.4 13.9L57.8 27.5C60.8 29.3 64.5 28.1 66.2 25.4C66.6 24.4 66.9 23.5 66.9 22.6Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4 28.7999C94.4 26.5999 96.2 24.7999 100.5 24.7999C102.7 24.7999 105.2 25.3999 107.4 26.7999L108.6 23.9C106.5 22.5 103.4 21.7 100.5 21.7C93.9 21.7 90.8 24.9999 90.8 28.9C90.8 38.2999 106.2 34.4 106.2 40.5C106.2 42.7 104.3 44.4 99.9 44.4C96.7 44.4 93.5 43.2 91.6 41.5L90.3 44.2999C92.3 46.1999 96.1 47.5 100 47.5C106.7 47.5 109.8 44.1999 109.8 40.2999C109.7 31.0999 94.4 34.9999 94.4 28.7999Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.6 22H122V47.3H125.6V22Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.7 22H140.1V47.3H157.4V44.2H143.7V22Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.1 36H184.8V32.9H172.1V25.2H186.3V22H168.5V47.3H186.9V44.2H172.1V36Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M217.8 40.9L202.6 22H199.7V47.3H203.3V28.5L218.4 47.3H221.4V22H217.8V40.9Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M232.3 25.2H241V47.3H244.6V25.2H253.2V22H232.3V25.2Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M274.3 22H263.4V47.3H269.2V40.3H274.3C281 40.3 285.3 36.8 285.3 31.2C285.3 25.5 281 22 274.3 22ZM273.9 35.6H269.1V26.8H273.9C277.5 26.8 279.3 28.4 279.3 31.2C279.3 33.9 277.6 35.6 273.9 35.6Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M313.2 36C313.2 40.8 311.1 42.8 307.6 42.8C304.1 42.8 302 40.8 302 36V22H296V36.2C296 43.6 300.3 47.7 307.4 47.7C314.6 47.7 318.9 43.6 318.9 36.2V22H313.1V36H313.2Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M336 29.2C336 27.6 337.3 26.3 340.8 26.3C343.1 26.3 345.5 26.9 347.8 28.3L349.6 23.8C347.3 22.3 344 21.6 340.8 21.6C333.6 21.6 330.2 25.2 330.2 29.5C330.2 38.9 344.9 35.6 344.9 40.3C344.9 41.9 343.5 43 340 43C337 43 333.8 41.9 331.7 40.4L329.7 44.8C331.9 46.5 336 47.7 340 47.7C347.2 47.7 350.7 44.1 350.7 39.9C350.6 30.6 336 33.8 336 29.2Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M379 22V32H367.5V22H361.6V47.3H367.5V36.9H379V47.3H384.8V22H379Z",
    fill: "white",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpLogo);
export default __webpack_public_path__ + "static/media/sp-logo.f495643e145cc9272009bc6230dc947e.svg";
export { ForwardRef as ReactComponent };